<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div id="groupModal2" class="modal-mask" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop  style="max-width: 100%;">
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal-body- modal_add_rep d-none- mb-3" style="margin-left: 8px;">


          <div class="row">
            <div class="filterBtn" style="width: 100%; ">
                
                  <div class="col-12 float-left" style="padding-right: 18px !important;">
                    <div class="cp-filter-label col-3 p-0 float-left" style="margin-top: 20px;">Date Range:</div>
                    <b-form-select v-model="rep_days" 
                    @change="getAccountActivityLogs()"
                    :options="itemSource2" style="margin-bottom: 10px !important; margin-top: 12px;" class="col-9 float-left" />
                  </div>
                
            </div>
          </div>





                <div class="row mt-2 mb-3 align-items-end">
                  <div class="col" v-if="(($store.state.roles.indexOf('ROLE_MENTEE') > -1) || ($store.state.roles.indexOf('ROLE_APPRENTICE') > -1))">
                    <div class="h4 mb-0 text-uppercase">Activity</div>
                  </div>
                  <div class="col" v-else>
                    <div class="h4 mb-0 text-uppercase">Reps Recorded</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="row mb-2 pl-3 pr-3" v-for="(activityLog, index) in accountActivityLogs" :key="index">
                      <div class="col">
                        <div class="row pb-2 border-bottom">
                          <div class="col-9">
                            <div class="mb-0">{{ activityLog.title }}</div>
                            <div v-if="(($store.state.roles.indexOf('ROLE_MENTEE') > -1) || ($store.state.roles.indexOf('ROLE_APPRENTICE') > -1))" class="small text-muted mb-0">{{ activityLog.description1 }}</div>
                            <div v-else class="small text-muted mb-0">{{ activityLog.description }}</div>

                          </div>
                          <div class="col-3 small text-right text-muted">{{ activityLog.createdAtFormatted }}</div>
                        </div>
                      </div>
                    </div>
                    
                    

                    <div class="row" v-if="accountActivityLogs.length == 0 && loading == false">
                      <div class="col">
                        <div>No logs.</div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>

            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import axios from 'axios';
import router from '../../router/index.js';

export default {
  props: ['isModalVisible', 'menteeId'],
  data() {
    return {
      accountActivityLogs: [],
      loading: false,
      itemSource2: [
          { value: "", text: "Select Date Range" }, 
          { value: "7", text: "Last 7 days" }, 
          { value: "15", text: "Last 15 days" },
          { value: "30", text: "Last 30 days" },
          { value: "180", text: "Last 6 Months" },
          { value: "All", text: "All Time" }
      ],
      rep_days: 7,

    }
  },
  computed: {
    
  },
  methods: {
    hide() {
      this.$emit('closeTasksLoggedFullListModal');
    },
    viewCourseReport: function(url) {
        window.open(url, '_blank');
    },

    viewReport: function(id) {
       let routeData = this.$router.resolve({name: 'assessmentreportnew', params: {assessmentAttemptId: id}});
        window.open(routeData.href, '_blank');
    },
    getActivityData() {
      this.rep_days = 7;
      this.accountActivityLogs = [];
      this.getAccountActivityLogs();  
    },
    getAccountActivityLogs() {
      this.accountActivityLogs = [];
      this.loading = true;
      const params = {};
      
      if (this.rep_days) {
          params.days = this.rep_days;
      } else {
          params.days = '';
      }
      params.account_id = this.$store.state.user_accountid;
      params.mentee_id = this.menteeId;
      axios.get('/desktop/v2/manager/mentee-task-logged/full-list', {
        params: params
      })
      .then(response =>  {
        this.loading = false;
        let data = response.data;
        this.accountActivityLogs = this.accountActivityLogs.concat(data.account_activity_logs);
      })
      .catch(function() {});
    },
  },
  components: {
  },
  created() {
  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}


::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/manager/mentee_tasks_logged_full_list.vue